import Layout from '@/pages/layout/'

export const topBar = [
	{
		path: "/",
		name: "home",
		redirect: "/home",
		meta: {
			title: "首页",
		},
		component: Layout,
		children: [
			{
				path: "/home",
				name: "home",
				title: "首页",
				meta:{
                //   keepAlive:true,
				  deepth: 0.5
				},
				component: () => import('@/pages/home')
			},
			{
				path: "/news",
				name: "news",
				meta:{
					deepth: 1,
					keepAlive:true
				  },
				title: "新闻中心",
				component: () => import('@/pages/news')
			},
			{
				path: "/djgj",
				name: "djgj",
				title: "党建共建",
				component: () => import('@/pages/news')
			},
			{
				path: "/dwgk",
				name: "dwgk",
				title: "党务公开",
				component: () => import('@/pages/news')
			},
			{
				path: "/tzgg",
				name: "tzgg",
				title: "通知公告",
				component: () => import('@/pages/tzgg')
			},
			{
				path: "/tjdj",
				name: "tjdj",
				meta:{
				
					deepth: 0.5
				  },
				title: "图解党建",
				component: () => import('@/pages/tjdj')
			}
			,
			{
				path: "/zcjd",
				name: "zcjd",
				meta:{
					deepth: 0.5
				  },
				title: "政策解读",
				component: () => import('@/pages/tzgg')
			},
			{
				path: "/djbk",
				name: "djbk",
				meta:{
					
					deepth: 0.5
				  },
				title: "党建百科",
				component: () => import('@/pages/djbk')
			},
			{
				path: "/djxx",
				name: "djxx",
				meta:{
					// keepAlive:true,
					deepth: 0.5
				  },
				title: "党建学习",
				component: () => import('@/pages/djxx')
			},
			{
				path: "/jpdk",
				name: "jpdk",
				meta:{
					keepAlive:true,
					deepth: 1
				  },
				title: "精品党课",
				component: () => import('@/pages/jpdk/index.vue')
			},
			{
				path: "/jpdkDetail",
				name: "jpdkDetail",
				title: "精品党课详情",
				component: () => import('@/pages/jpdk/jpdkDetail.vue')
			},
			{
				path: "/djxxDetail",
				name: "djxxDetail",
				meta:{
					
					deepth: 1
				  },
				title: "党建学习详情",
				component: () => import('@/pages/djxx/djxxDetail.vue')
			},
			{
				path: "/djxxResouce",
				name: "djxxResouce",
				title: "党建学习资源",
				component: () => import('@/pages/djxx/roucePlay.vue')
			},
			{
				path: "/yxzlResouce",
				name: "yxzlResouce",
				meta:{
					
					deepth: 3
				  },
				title: "院校专栏资源详情",
				component: () => import('@/pages/yxzl/roucePlay.vue')
			},
			{
				path: "/djxxResouce2",
				name: "djxxResouce2",
				title: "党建学习资源",
				component: () => import('@/pages/djxx/roucePlay2.vue')
			},

			{
				path: '/ztpx',
				name: 'ztpx',
				meta:{
					// keepAlive:true,
					deepth: 0.5
				  },
				title: '专题培训',
				component: () => import('@/pages/ztpx/index.vue'),
			},
			{
				path: '/ztpxDetail',
				name: 'ztpxDetail',
				title: '专题培训详情',
				component: () => import('@/pages/ztpx/ztpxDetail.vue'),
			},
			{
				path: '/yxzl',
				meta:{
					// keepAlive:true,
					deepth: 0.5
				  },
				name: 'yxzl',
				title: '院校专栏',
				component: () => import('@/pages/yxzl/index.vue'),
			},
			{
				path: '/zzsh',
				name: 'zzsh',
				title: '组织生活',
				component: () => import('@/pages/zzsh/index.vue'),
			},
			{
				path: '/zzshDetail',
				name: 'zzshDetail',
				title: '组织生活详情',
				component: () => import('@/pages/zzsh/zzshDetail.vue'),
			},
			// 组织生活资源播放
			{
				path: '/roucePlay',
				name: 'roucePlay',
				title: '资源播放',
				component: () => import('@/pages/zzsh/roucePlay.vue'),
			},
			{
				path: "/xwxq",
				name: "xwxq",
				meta:{
					deepth: 2,
				},
				title: "新闻详情",
				component: () => import('@/pages/news/newDetail.vue')
			},
			{
				path: "/tidj_detail",
				
				name: "tidj_detail",
				title: "图解党建详情",
				component: () => import('@/pages/tjdj/tjdjDetail.vue')
			},
			{
				path: "/tzgg_detail",
				name: "tzgg_detail",
				meta:{
					deepth: 2,
				},
				title: "通知公告详情",
				component: () => import('@/pages/tzgg/tzggDetail.vue')
			},
			{
				path: "/tssz",
				name: "tssz",
				meta:{
					
					deepth: 0.5
				  },
				title: "图说时政",
				component: () => import('@/pages/tssz')
			},
			{
				path: "/userCenter",
				name: "userCenter",
				title: "个人中心",
				component: () => import('@/pages/userCenter')
			},

			{
				path: "/onLineExam",
				name: "onLineExam",
				title: "在线考试",
				component: () => import('@/pages/userCenter/onelineExam.vue')
			},
			{
				path: "/onLineExamDetail",
				name: "onLineExamDetail",
				title: "在线考试详情",
				component: () => import('@/pages/userCenter/onelineExamDetail.vue')
			},
			{
				path: "/xsx",
				name: "xsx",
				title: "习思想",
				component: () => import('@/pages/xsx')
			},
			{
				path: "/xsxDeyail",
				name: "xsxDeyail",
				title: "习思想详情",
				component: () => import('@/pages/xsx/roucePlay.vue')
			},
			{
				path: "/zxtj",
				name: "zxtj",
				meta:{
					keepAlive:true
				  },
				title: "最新推荐",
				component: () => import('@/pages/zxtj/index.vue')
			},
			{
				path: "/zxtjDetail",
				name: "zxtjDetail",
				title: "最新推荐详情",
				component: () => import('@/pages/zxtj/zxtjDetail.vue')
			},
		
			{
				path: "/search",
				name: "search",
				title: "资源检索",
				component: () => import('@/pages/search/index.vue')
			},{
				path: "/hsyzt",
				name: "hsyzt",
				meta:{
					
					deepth: 0.5
				  },
				title: "红色云展厅",
				component: () => import('@/pages/hsyzt/index.vue')
			},
			{
				path: "/hsyztDetail",
				name: "hsyztDetail",
				meta:{
				
					deepth: 3
				  },
				title: "云展厅详情",
				component: () => import('@/pages/hsyzt/hsyztDetail.vue')
			},
			{
				path: "/audioDetail",
				name: "audioDetail",
				meta:{
				
					deepth: 3
				  },
				title: "音频详情",
				component: () => import('@/pages/djxx/audioDetail.vue')
			},
		]
	},
	{
		path: "*",
		name: "error",
		meta: {
			title: "错误"
		},
		component: () => import('@/pages/error')
	},
	{
		path:"/djxc",
		name:"党建宣传",
		meta:{
			template:289
		},
		component:() => import(/* webpackChunkName: 'pages' */ "@/pages/djxc/djxc.vue"),
	},
	{
		path:"/rdsc",
		name:"入党誓词",
		meta:{
			keepAlive:false
		},
		component:() => import(/* webpackChunkName:'page'*/ "@/pages/rdsc/rdsc"),
	}
]
export const routers = topBar